import { Link } from "react-router-dom";
import { BUILD_HASH } from "@/config/version";

export function Footer() {
  // Minimal styling (no border, no background) is intentional for seamless ad-to-footer transition
  return (
    <footer className="w-full relative mt-0 animate-fade-up" data-debug-ignore-a11y>
      <div className="max-w-4xl mx-auto px-4 pt-0 pb-3 md:px-2 md:pt-0 md:pb-2 md:landscape:pb-1.5 lg:landscape:pb-2">
        <div className="flex flex-row flex-nowrap items-center justify-center gap-1.5 text-[10px] sm:text-xs text-muted-foreground whitespace-nowrap">
          <span className="hidden sm:inline">© 2025 Wormble</span>
          <span className="sm:hidden">© 2025</span>
          <span aria-hidden="true">•</span>
          <nav className="flex flex-row items-center gap-1.5 flex-nowrap justify-center" aria-label="Footer navigation">
            <Link 
              to="/about" 
              className="hover:text-foreground transition-colors py-1 px-1 sm:px-2 -mx-1 sm:-mx-2"
            >
              About
            </Link>
            <span aria-hidden="true">•</span>
            <Link 
              to="/help" 
              className="hover:text-foreground transition-colors py-1 px-1 sm:px-2 -mx-1 sm:-mx-2"
            >
              Help
            </Link>
            <span aria-hidden="true">•</span>
            <Link 
              to="/privacy" 
              className="hover:text-foreground transition-colors py-1 px-1 sm:px-2 -mx-1 sm:-mx-2"
            >
              Privacy
            </Link>
            <span aria-hidden="true">•</span>
            <Link 
              to="/contact" 
              className="hover:text-foreground transition-colors py-1 px-1 sm:px-2 -mx-1 sm:-mx-2"
            >
              Contact
            </Link>
            <span aria-hidden="true">•</span>
            <span 
              className="text-muted-foreground font-mono text-[9px] sm:text-[10px]" 
              title={`Build: ${BUILD_HASH}`}
            >
              v{BUILD_HASH.slice(0, 7)}
            </span>
          </nav>
        </div>
      </div>
    </footer>
  );
}
